import '../scss/blog.scss';

import "../components/main-blog";

document.addEventListener('DOMContentLoaded', () => {
  function handleize(text) {
    return text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  const summaryToggle = document.querySelector('#summary_toggle');
  const breadcrumbsElement = document.querySelector('.breadcrumb');
  const mainArticleElement = document.querySelector('.main-article');
  const summaryElement = document.querySelector('#summary');


  if (!summaryToggle) return;

  summaryToggle.addEventListener('click', () => {
    let isActive = summaryToggle.parentNode.dataset.active;

    if (isActive == 'true') {
      summaryToggle.parentNode.setAttribute('data-active', false);
    } else {
      summaryToggle.parentNode.setAttribute('data-active', true);
    }
  });

  function moveSummaryElement() {
    if (window.innerWidth < 992) {
      breadcrumbsElement.insertAdjacentElement('beforebegin', summaryElement);
    } else {
      mainArticleElement.prepend(summaryElement);
    }
  }

  moveSummaryElement();

  const summaryList = document.querySelector('#article_summary');
  const article = document.querySelector('#article_content');
  const headers = article.querySelectorAll('h2:not(.not-summary__heading)');
  const bullet = window.article_bullet;
  let listItems = [];

  headers.forEach((header, index) => {
    if (!header.querySelector('img')) {
      if (header.tagName === 'H2') {
        const handleizedText = handleize(header.textContent);
        header.setAttribute('data-href', handleizedText);
      }

      index += 1;

      const listItem = document.createElement('li');
      listItem.setAttribute('data-href', handleize(header.textContent));
      const headerItem = '<i>' +index+'.</i><span>' + header.textContent.trim() + '</span>' + bullet;

      listItem.innerHTML = headerItem;
      summaryList.appendChild(listItem);

      listItems.push(listItem);
    }
  });

  if (listItems[0]) {
    listItems[0].classList.add('active');
  }

  window.addEventListener('resize', moveSummaryElement);

  let disableScrollSpy = false;

  const summaryOptions = summaryList.querySelectorAll('#summary li[data-href]');
  summaryOptions.forEach(option => {
    option.addEventListener('click', (event) => {
      event.preventDefault();
      disableScrollSpy = true;

      const href = option.dataset.href;
      const title = article.querySelector('#article_content [data-href="' + href + '"]');

      const headerHeight = document.querySelector('header.js-header')?.offsetHeight || 0;
      const articleSummary = document.querySelector('.jc-main-article__summary')?.offsetHeight || 0;
      let offset = headerHeight || 80;
        
      if (window.innerWidth < 992 && articleSummary) {
        offset += articleSummary;
      }

      window.scrollTo({
        top: title.getBoundingClientRect().top + document.documentElement.scrollTop - offset - 20,
        behavior: 'smooth',
      });
      setActiveByHref(href);
      setTimeout(() => {
        disableScrollSpy = false;
      }, 800);
    });
  })

  let activeHeader = listItems[0] || null;
  let activeTarget = listItems[0] || null;

  const trackedHeaders = Array.from(article.querySelectorAll('h2[data-href]:not(.not-summary__heading)'));

  let TOP_OFFSET_PX = 80;

  const setActiveByHref = (href) => {
    if (!href) return;

    const nextActive = document.querySelector(`#article_summary [data-href="${href}"]`);
    if (!nextActive) return;

    if (activeHeader && activeHeader !== nextActive) {
      activeHeader.classList.remove('active');
    }

    nextActive.classList.add('active');
    activeHeader = nextActive;
    activeTarget = nextActive;
  };

  let headerTops = [];

  const getDocTop = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top + window.scrollY;
  };

  const recalcHeaderTops = () => {
    headerTops = trackedHeaders.map((h) => ({
      el: h,
      href: h.getAttribute('data-href'),
      top: getDocTop(h),
    }));
  };

  recalcHeaderTops();

  window.addEventListener('resize', () => {
    recalcHeaderTops();
    throttledScrollSpy();
  });

  window.addEventListener('load', () => {
    recalcHeaderTops();
    throttledScrollSpy();
  });

  const getActiveHeaderByLine = () => {
    if (!headerTops.length) return null;
    const headerHeight = document.querySelector('header.js-header').offsetHeight;
    const articleSummary = document.querySelector('.jc-main-article__summary').offsetHeight;

    if (headerHeight) {
      TOP_OFFSET_PX = headerHeight;
    }

    if (window.innerWidth < 992 && articleSummary) {
      TOP_OFFSET_PX += articleSummary;
    }

    const lineY = window.scrollY + TOP_OFFSET_PX;

    let active = null;
    for (let i = 0; i < headerTops.length; i++) {
      if (headerTops[i].top <= lineY + 150) active = headerTops[i];
      else break;
    }
    return active;
  };

  const trackPositionAndStatus = () => {
    const activeHeaderObj = getActiveHeaderByLine();
    if (!activeHeaderObj || disableScrollSpy) return;

    const href = activeHeaderObj.href;
    const currentHref = activeTarget?.getAttribute('data-href');
    if (href && href !== currentHref) {
      setActiveByHref(href);
    }
  };

  const throttle = (fn, wait) => {
    let lastTime = 0;
    return function (...args) {
      const now = Date.now();
      if (now - lastTime >= wait) {
        lastTime = now;
        fn.apply(this, args);
      }
    };
  };

  const throttledScrollSpy = throttle(trackPositionAndStatus, 100);

  window.addEventListener('scroll', throttledScrollSpy);
  window.addEventListener('resize', throttledScrollSpy);
  trackPositionAndStatus();

});

